import { Component } from '@angular/core';
// import { BarcodeScanner } from '@capacitor-community/barcode-scanner';
import { ModalController } from '@ionic/angular';

@Component({
    selector: 'app-mm-barcode-scanner',
    templateUrl: './mm-barcode-scanner.component.html',
    styleUrls: ['./mm-barcode-scanner.component.scss'],
})
export class MmBarcodeScannerComponent {

    scanActive: boolean = false;

    constructor(private modalCtrl: ModalController) { }

    async ionViewWillEnter() {

        const allowed = await this.checkPermission();

        if (allowed) {
            this.scanActive = true;
            // BarcodeScanner.hideBackground();

            this.hideOrShowContentApp(['main'], true);

            const result: any = null // await BarcodeScanner.startScan();

            if (result.hasContent) {
                this.scanActive = false;
                await this.stopScanner(result.content)
            } else {
                console.log('NO DATA FOUND!');
                await this.stopScanner(null)
            }
        } else {
            console.log('NOT ALLOWED!');
            await this.stopScanner(null)
        }
    }

    async checkPermission() {
        return new Promise(async (resolve) => {
            const status: any = null; //await BarcodeScanner.checkPermission({ force: true });
            if (status.granted) {
                resolve(true);
            } else if (status.denied) {
                // BarcodeScanner.openAppSettings();
                resolve(false);
            }
        });
    }

    async stopScanner(qrCodeData: any) {
        // BarcodeScanner.stopScan();
        this.hideOrShowContentApp(['main'], false);
        this.scanActive = false;
        await this.modalCtrl.dismiss(qrCodeData);
    }


    hideOrShowContentApp(listElements: any[], isToHide: boolean) {
        return listElements.forEach(item => {
            setTimeout(() => {
                document.getElementById(item)?.style.setProperty('visibility', isToHide ? 'hidden' : 'visible');
            }, 10);
        });
    }


    async toggleTorch() {
        console.log('toggleTorch');
        // await BarcodeScanner.toggleTorch();
    }
}
